// extracted by mini-css-extract-plugin
module.exports = {"container":"SignOutIcon_container__3M_k6","group":"SignOutIcon_group__2Yb04"};